import axios from 'axios';

const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000'}/api`;
const API_URL = `${API_BASE_URL}/notifications`;

const getAuthHeader = () => {
  const token = sessionStorage.getItem('token');
  return {
    Authorization: `Bearer ${token}`
  };
};

const notificationService = {
  // Get all notifications with optional filters and pagination
  getNotifications: async (type = null, isRead = null, page = 1, limit = 20) => {
    try {
      const params = {};
      if (type) params.type = type;
      if (isRead !== null) params.isRead = isRead;
      params.page = page;
      params.limit = limit;

      const response = await axios.get(API_URL, {
        headers: getAuthHeader(),
        params
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Get unread notification count
  getUnreadCount: async () => {
    try {
      const response = await axios.get(`${API_URL}/unread/count`, {
        headers: getAuthHeader()
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Mark single notification as read
  markAsRead: async (notificationId) => {
    try {
      const response = await axios.patch(
        `${API_URL}/${notificationId}/read`,
        {},
        {
          headers: getAuthHeader()
        }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Mark all notifications as read
  markAllAsRead: async () => {
    try {
      const response = await axios.patch(
        `${API_URL}/read-all`,
        {},
        {
          headers: getAuthHeader()
        }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Delete single notification
  deleteNotification: async (notificationId) => {
    try {
      const response = await axios.delete(`${API_URL}/${notificationId}`, {
        headers: getAuthHeader()
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Delete all notifications
  deleteAllNotifications: async () => {
    try {
      const response = await axios.delete(API_URL, {
        headers: getAuthHeader()
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};

export default notificationService;
